<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-stretch justify-start space-y-4">


  @if (!isLightVersion) {
    <div class="w-full space-y-3">
      <app-selected
        class="w-full block"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
      ></app-selected>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['indact'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getOptionLabel('indact', dataLastOnboarding['indact']) }}
            </span>
          </div>
        </div>
      }
    </div>

    <div class="w-full space-y-3">
      <app-autocomplete
        label="Actividad económica"
        searchType="remote"
        [remoteSearchFn]="_listService.searchEconomicActivity.bind(_listService)"
        [defaultValue]="defaultData?.econmicActivity"
        [findByIdFn]="_listService.findByIdEconomicActivity.bind(_listService)"
        labelKey="name"
        valueKey="id"
        [showBlocker]="true"
        (valueChange)="handleAutocompleteValue($event)"
      >
      </app-autocomplete>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['econmicActivity'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getEconomicActivityLabel(dataLastOnboarding['econmicActivity']) }}
            </span>
          </div>
        </div>
      }
    </div>
  }

  @for (config of lightDataInputs(); track config.formName) {
    <div class="w-full space-y-3">
      <app-input
        class="w-full block"
        [config]="config"
        (submitValue)="handleValue($event)"
      ></app-input>

      <!-- Dato anterior para inputs -->
      @if (isCheckData && dataLastOnboarding && dataLastOnboarding[config.formName ?? ''] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ dataLastOnboarding[config.formName ?? ''] | number:'1.0-0' }}
            </span>
          </div>
          <span class="text-xs text-label">COP</span>
        </div>
      }
    </div>
  }

  @if (!isLightVersion) {
    <div class="w-full space-y-3">
      <app-selected
        class="w-full block"
        [config]="dataSelected().at(1)"
        (selectValue)="handleValue($event)"
      ></app-selected>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['academic'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getOptionLabel('academic', dataLastOnboarding['academic']) }}
            </span>
          </div>
        </div>
      }
    </div>

    <div class="w-full space-y-3">
      <app-autocomplete
        label="¿Cuál es tu profesión?"
        searchType="local"
        [items]="codpros"
        labelKey="label"
        valueKey="value"
        [defaultValue]="defaultData?.codpro"
        [showBlocker]="true"
                (valueChange)="setCodpro($event)"
      >
      </app-autocomplete>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['codpro'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getProfessionLabel(dataLastOnboarding['codpro']) }}
            </span>
          </div>
        </div>
      }
    </div>

    <div class="w-full space-y-3">
      <app-selected
        class="w-full block"
        [config]="dataSelected().at(2)"
        (selectValue)="handleValue($event)"
      ></app-selected>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['specialProtecionProgram'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getOptionLabel('specialProtecionProgram', dataLastOnboarding['specialProtecionProgram']) }}
            </span>
          </div>
        </div>
      }
    </div>
  }

</form>
